import { Set } from '../../index.js';
import { Length } from '../../values/index.js';
import { VariantReference } from '../basic/font.js';
export const normalizeReusableTypographySize = (props = {}) => ({
    fontSize: props.fontSize === null || props.fontSize === undefined ? null : Length(props.fontSize),
    lineHeight: props.lineHeight === null || props.lineHeight === undefined ? null : Length(props.lineHeight),
    letterSpacing: props.letterSpacing === null || props.letterSpacing === undefined ? null : Length(props.letterSpacing),
    paragraphSpacing: props.paragraphSpacing === null || props.paragraphSpacing === undefined ? null : Length(props.paragraphSpacing),
    iconSize: props.iconSize === null || props.iconSize === undefined ? null : Length(props.iconSize)
});
export const Size = (props) => normalizeReusableTypographySize(props);
Size.isValid = (props) => {
    var _a, _b, _c, _d, _e;
    return ((_a = props.fontSize) === null || _a === void 0 ? void 0 : _a.value) !== null ||
        ((_b = props.lineHeight) === null || _b === void 0 ? void 0 : _b.value) !== null ||
        ((_c = props.letterSpacing) === null || _c === void 0 ? void 0 : _c.value) !== null ||
        ((_d = props.paragraphSpacing) === null || _d === void 0 ? void 0 : _d.value) !== null ||
        ((_e = props.iconSize) === null || _e === void 0 ? void 0 : _e.value) !== null;
};
export const Props = (props = {}) => ({
    fontVariant: props.fontVariant || null,
    allowBoldAndItalic: !!props.allowBoldAndItalic,
    textTransform: props.textTransform,
    base: Size(props.base),
    overrides: Object.keys(props.overrides || {}).reduce((object, breakpoint) => {
        const normalized = Size(props.overrides[breakpoint]);
        if (Size.isValid(normalized) && breakpoint !== 'new') {
            return Object.assign(object, { [breakpoint]: normalized });
        }
        return object;
    }, {})
});
export const fix = (props, styles) => ({
    ...props,
    fontVariant: VariantReference.Fix(props.fontVariant, styles)
});
export const validate = () => true;
export const label = 'Typography';
export const type = 'typography';
export const property = 'typographyIds';
export const category = 'aspect';
export const forms = [
    {
        id: 'typographyType',
        label: 'Font',
        extractProperties: ({ fontVariant }) => ({
            fontVariant
        }),
        validate: ({ fontVariant }) => true
    },
    {
        id: 'typographySize',
        label: 'Settings',
        extractProperties: (props) => ({ base: Size(props.base) }),
        validate: (props) => Size.isValid(props.base)
    }
];
export const summarize = (props, styles, formId) => {
    var _a;
    const font = Set.findByTypeAndId(styles || [], 'font', (_a = props.fontVariant) === null || _a === void 0 ? void 0 : _a.id);
    switch (formId) {
        case 'typographyType':
            return (font === null || font === void 0 ? void 0 : font.props.familyName) || 'Inherit';
        case 'typographySize':
            return props.base.fontSize ? props.base.fontSize.value + props.base.fontSize.unit : 'Inherit';
        default:
            return (font === null || font === void 0 ? void 0 : font.props.familyName) || 'Inherit';
    }
};
//# sourceMappingURL=typography.js.map